const tableOption = function () {
  return {
    stripe: true,
    page: true,
    maxHeight: "100%",
    align: "center",
    header: false,
    index: true,
    selection: true,
    emptyText: "暂无数据",
    column: [
      {
        label: "仪表编号",
        prop: "waterCode",
      },
      {
        label: "仪表名称",
        prop: "waterName",
        search: true,
        clearable: true,
      },
      {
        label: "仪表类型",
        prop: "waterType",
        type: "select",
        dicData: [
          {
            label: '智能水表',
            value: '0'
          }
        ],
        formatter: function (row, value) {
          if (Number(value) === 0) {
            return "智能水表";
          }
          return "";
        }
      },
      {
        label: "仪表位置",
        prop: "waterPosition",
      },
      {
        label: "抄表日期",
        prop: "recordDate",
        search: true,
        clearable: true,
        searchSlot: true,
      },
      {
        label: "抄表读数",
        prop: "currentValue",
      },
      {
        label: "本期用量",
        prop: "currentNum",
      }
    ]
  };
};

export default tableOption;
